"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const apiActions = __importStar(require("api-actions"));
const components_1 = require("components");
const config_1 = require("config");
const local_storage_1 = require("local-storage");
const utils_1 = require("utils");
const actions = __importStar(require("../actions"));
const reducer_1 = require("../reducer");
const SiteInitializationLayout_1 = __importDefault(require("./SiteInitializationLayout"));
function AllLocationsProvider({ allLocations, children, clearAllLocations, fetchAllLocationsForManager, fetchLocationDetails, currentLocation, }) {
    const [managerAccessError, setManagerAccessError] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        fetchAllLocationsForManager().catch((error) => {
            if (error?.response?.errorCode === 'manager_not_found') {
                setManagerAccessError(true);
            }
        });
        return () => clearAllLocations();
    }, []);
    if (managerAccessError || (allLocations && allLocations.length === 0)) {
        return (0, jsx_runtime_1.jsx)(react_router_dom_1.Redirect, { to: config_1.NO_MANAGER_ACCESS_URL });
    }
    if (!allLocations)
        return (0, jsx_runtime_1.jsx)(SiteInitializing, {});
    if (!currentLocation ||
        !currentLocation.locationId ||
        !currentLocation.permissions) {
        const persistedLocation = (0, local_storage_1.getLocation)();
        const defaultLocation = persistedLocation &&
            allLocations.some((location) => location.locationId === persistedLocation.locationId)
            ? persistedLocation
            : allLocations[0];
        fetchLocationDetails(defaultLocation.locationId).then((res) => (0, local_storage_1.setLocation)(res));
        return (0, jsx_runtime_1.jsx)(SiteInitializing, {});
    }
    return children;
}
function mapStateToProps(state) {
    return {
        allLocations: reducer_1.selectors.allLocations(state),
        currentLocation: reducer_1.selectors.currentLocation(state),
    };
}
const mapDispatchToProps = {
    clearAllLocations: actions.clearAllLocations,
};
const mapApiAuthToProps = {
    fetchAllLocationsForManager: apiActions.fetchAllLocationsForManager,
    fetchLocationDetails: apiActions.fetchLocationDetails,
};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, utils_1.withApiAuth)(mapApiAuthToProps))(AllLocationsProvider);
function SiteInitializing() {
    return ((0, jsx_runtime_1.jsx)(SiteInitializationLayout_1.default, { children: (0, jsx_runtime_1.jsx)(components_1.Spinner, { centerPage: true }) }));
}
